import React from "react";

const Navbar = () => {
  
  

  let imgUrl =
  "https://fontmeme.com/permalink/211208/2a9e21302fa17078d2032971aff86d58.png";
  return (
    <nav>
      <div>
        
          <img src={imgUrl} alt="font" />
      
        
      </div>
    
    </nav>
  );
};

export default Navbar;
